<template>
  <div id="app">
    <!-- <keep-alive v-if="$route.meta.keepAlive">
      <router-view/>
    </keep-alive> -->
    <router-view />
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
html,body{
  width: 100%;
  height: 100%;
  min-width: 1124px;
}
.mobile-msg{
  text-align: center;
  line-height: 300px;
}
#app{
  width: 100%;
  height: 100%;
}
</style>
